import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "slotbooking-tabs status-tabs mb-5"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('仓库')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "animated": false,
      "size": "small",
      "data-permission": "product_wrapper_warehouse_code",
      "id": "product_wrapper_warehouse_code"
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "tab": _vm.t('全部 {0}', [_vm.searchData.warehouse_code === undefined ? _vm.total !== null ? "(" + _vm.total + ")" : '' : ''])
    }
  }), _vm._l(_vm.warehouseList, function (item) {
    return _c('a-tab-pane', {
      key: item.warehouse_code
    }, [_c('div', {
      attrs: {
        "slot": "tab"
      },
      slot: "tab"
    }, [item.is_used ? _c('span', [_vm._v(_vm._s(_vm.searchData.warehouse_code === item.warehouse_code ? item.warehouse_name_text + (_vm.total !== null ? "(" + _vm.total + ")" : '') : item.warehouse_name_text))]) : _c('a-tooltip', {
      attrs: {
        "overlayClassName": "expandTooltip"
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.tc('仓库未开通')))]), _c('span', {
      staticStyle: {
        "color": "#ddd"
      }
    }, [_vm._v(_vm._s(_vm.searchData.warehouse_code === item.warehouse_code ? item.warehouse_name_text + (_vm.total !== null ? "(" + _vm.total + ")" : '') : item.warehouse_name_text))])])], 1)]);
  })], 2)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "allow-clear": false,
      "data-permission": "product_wrapper_code_type",
      "id": "product_wrapper_code_type"
    },
    model: {
      value: _vm.searchData.product_code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_code_field", $$v);
      },
      expression: "searchData.product_code_field"
    }
  }, _vm._l(_vm.packageProductEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 100,
      "data-permission": "product_wrapper_code_value",
      "id": "product_wrapper_code_value"
    },
    model: {
      value: _vm.searchData.product_code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_code_value", $$v);
      },
      expression: "searchData.product_code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "allow-clear": false,
      "data-permission": "product_wrapper_package_option",
      "id": "product_wrapper_package_option"
    },
    model: {
      value: _vm.searchData.package_option,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_option", $$v);
      },
      expression: "searchData.package_option"
    }
  }, _vm._l(_vm.packageOptionEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 50,
      "data-permission": "product_wrapper_package_option_value",
      "id": "product_wrapper_package_option_value"
    },
    model: {
      value: _vm.searchData.package_option_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_option_value", $$v);
      },
      expression: "searchData.package_option_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u662F\u5426\u9700\u8981\u5305\u6750"),
      "show-tip": "",
      "placeholder": _vm.t('是否需要包材'),
      "allowClear": "",
      "data-permission": "product_wrapper_need_package",
      "id": "product_wrapper_need_package"
    },
    model: {
      value: _vm.searchData.need_package,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "need_package", $$v);
      },
      expression: "searchData.need_package"
    }
  }, _vm._l(_vm.needPackageEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5305\u88C5\u9009\u62E9\u65B9"),
      "show-tip": "",
      "placeholder": _vm.t('包装选择方'),
      "allowClear": "",
      "data-permission": "product_wrapper_package_select",
      "id": "product_wrapper_package_select"
    },
    model: {
      value: _vm.searchData.package_select,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_select", $$v);
      },
      expression: "searchData.package_select"
    }
  }, _vm._l(_vm.packageSelectEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u8981\u6C42"),
      "show-tip": "",
      "placeholder": _vm.t('包材要求'),
      "allowClear": "",
      "data-permission": "product_wrapper_package_req",
      "id": "product_wrapper_package_req"
    },
    model: {
      value: _vm.searchData.package_req,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_req", $$v);
      },
      expression: "searchData.package_req"
    }
  }, _vm._l(_vm.packageReqAllEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u5F52\u5C5E"),
      "show-tip": "",
      "placeholder": _vm.t('包材归属'),
      "allowClear": "",
      "data-permission": "product_wrapper_sku_wrapper_source",
      "id": "product_wrapper_sku_wrapper_source"
    },
    model: {
      value: _vm.searchData.sku_wrapper_source,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "sku_wrapper_source", $$v);
      },
      expression: "searchData.sku_wrapper_source"
    }
  }, _vm._l(_vm.skuWrapperSourceEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u66F4\u65B0\u65F6\u95F4"),
      "allow-clear": false,
      "placeholder": _vm.t('更新时间'),
      "data-permission": "product_wrapper_time_type",
      "id": "product_wrapper_time_type"
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, _vm._l(_vm.packageTimeTypeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD",
      "data-permission": "product_wrapper_time_value",
      "id": "product_wrapper_time_value"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "product_wrapper_search",
      "data-permission": "product_wrapper_search",
      "id": "product_wrapper_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "product_wrapper_reset",
      "data-permission": "product_wrapper_reset",
      "id": "product_wrapper_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('span', {
    staticClass: "fl",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('div', {
    staticClass: "ml-20 fl"
  }, [_c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "product_wrapper_export_all",
      "id": "product_wrapper_export_all",
      "data-sign": "product_wrapper_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "product_wrapper_export_select",
      "id": "product_wrapper_export_select",
      "data-sign": "product_wrapper_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_wrapper_delete',
      expression: "'product_wrapper_delete'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "product_wrapper_delete_bulk",
      "id": "product_wrapper_delete_bulk",
      "data-sign": "product_wrapper_delete_bulk",
      "fbu-analyse-name": $t("\u5220\u9664")
    },
    on: {
      "click": _vm.handleDeleteBulk
    }
  }, [_vm._v(" " + _vm._s(_vm.t('删除')))])], 1), _c('div', {
    staticClass: "fr"
  }, [_c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_wrapper_setting',
      expression: "'product_wrapper_setting'"
    }],
    staticClass: "mr-10",
    attrs: {
      "data-permission": "product_wrapper_setting",
      "id": "product_wrapper_setting",
      "data-sign": "product_wrapper_setting",
      "fbu-analyse-name": $t("\u5546\u54C1\u5305\u6750\u8BBE\u7F6E")
    },
    on: {
      "click": _vm.handleSetting
    }
  }, [_vm._v(" " + _vm._s(_vm.t('商品包材设置')))]), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_wrapper_add',
      expression: "'product_wrapper_add'"
    }],
    staticClass: "mr-10",
    attrs: {
      "data-permission": "product_wrapper_add_bluk",
      "id": "product_wrapper_add_bluk",
      "data-sign": "product_wrapper_add_bluk",
      "fbu-analyse-name": $t("\u6279\u91CF\u66F4\u65B0")
    },
    on: {
      "click": _vm.handleAddBulk
    }
  }, [_vm._v(" " + _vm._s(_vm.t('批量更新')))]), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'product_wrapper_add',
      expression: "'product_wrapper_add'"
    }],
    attrs: {
      "data-permission": "product_wrapper_add",
      "id": "product_wrapper_add",
      "data-sign": "product_wrapper_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.t('新增')))])], 1)]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "name": "productWrapperList",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "fixed-header": "",
      "data-sign": "product_wrapper_list",
      "is-filter-box": "",
      "row-selection": _vm.rowSelection,
      "row-key": "id",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [_c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(_vm.getWarehouseName(record))))])]);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('创建')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.create_time)))])]), _c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('更新')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.update_time)))])])]);
      }
    }, {
      key: "package_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.package_code,
            expression: "record.package_code"
          }]
        }, [_vm._v(_vm._s(_vm._f("filterEmpty")(record.package_code)) + " ")]), record.recommend === 1 ? _c('a-tooltip', {
          attrs: {
            "placement": "right",
            "title": _vm.t('选择包材要求后，系统自动推荐的包材')
          }
        }, [_c('i', {
          staticClass: "fa fa-bookmark ml-5 note-icon-warning"
        })]) : _vm._e()], 1);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [_c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'product_wrapper_edit',
            expression: "'product_wrapper_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "product_wrapper_edit",
            "id": "product_wrapper_edit",
            "data-sign": "product_wrapper_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]), _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'product_wrapper_delete',
            expression: "'product_wrapper_delete'"
          }],
          attrs: {
            "data-permission": "product_wrapper_delete",
            "id": "product_wrapper_delete",
            "data-sign": "product_wrapper_delete",
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('删除')))])]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "name": "productWrapperList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('add-edit-modal', {
    attrs: {
      "visible": _vm.addEditVisible,
      "rowData": _vm.rowData
    },
    on: {
      "update:visible": function ($event) {
        _vm.addEditVisible = $event;
      },
      "success": _vm.handleUpdateSuccess
    }
  }), _c('setting', {
    attrs: {
      "visible": _vm.settingVisible,
      "rowData": _vm.rowData
    },
    on: {
      "update:visible": function ($event) {
        _vm.settingVisible = $event;
      },
      "success": _vm.handleUpdateSuccess
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };